import apiCall from '../../index'

const apiService = '/api-erppalmas/api/v1/reclutamiento/ficha_reclutamiento_det'

const service = {
  findAll(params) {
    const query = `?estado=${params.estado}&idFichaReclutamiento=${params.idFichaReclutamiento}&query=${params.query}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  create(model) {
    return new Promise((resolve, reject) => {
      apiCall
        .post(apiService, model)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  update(model) {
    return new Promise((resolve, reject) => {
      apiCall
        .put(apiService, model)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  updateEstado(params) {
    const query = `/update_estado?estado=${params.estado}&idFichaReclutamientoDetalle=${params.idFichaReclutamientoDetalle}`
    return new Promise((resolve, reject) => {
      apiCall
        .put(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  delete(params) {
    return new Promise((resolve, reject) => {
      apiCall
        .delete(`${apiService}/${params.id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
